import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'

/** Identifies which surface in the app a CTA was shown on or clicked from. */
export const CTA_KEY = {
  SCHEDULING_PAGE_BANNER: 'scheduling_page_banner',
  POPOVER_BANNER: 'popover_banner',
  CALLIE_HERO: 'callie_hero',
  SCHEDULING_PAGE: 'scheduling_page',
  MARKETING_EMAIL: 'marketing_email',
}

const TRY_EMAIL_AGENT = { cta_details: 'try_email_agent' }

const trackCtaClicked = (track, properties) => track({
  name: TRACKING_EVENT_NAMES.CTA_CLICKED,
  properties,
})

const trackButtonClick = (track, ctaKey, ctaText) => trackCtaClicked(track, {
  cta_key: ctaKey,
  cta_text: ctaText,
  ...TRY_EMAIL_AGENT,
})

const trackDismissAction = (track, ctaKey, ctaText) => trackCtaClicked(track, {
  cta_key: ctaKey,
  cta_text: ctaText,
  action: 'dismissed',
})

export const bannerShownEvent = {
  name: TRACKING_EVENT_NAMES.CTA_SHOWN,
  properties: {
    cta_key: CTA_KEY.SCHEDULING_PAGE_BANNER,
    cta_text: 'email_agent_banner_shown',
  },
}

export const trackSchedulingPageBannerTryItOutClicked = (track) => trackButtonClick(
  track,
  CTA_KEY.SCHEDULING_PAGE_BANNER,
  'try_it_out',
)

export const trackPopoverBannerTryItOutClicked = (track) => trackButtonClick(
  track,
  CTA_KEY.POPOVER_BANNER,
  'try_it_out',
)

export const trackSchedulingPageBannerWatchHowItWorksClicked = (track) => trackButtonClick(
  track,
  CTA_KEY.SCHEDULING_PAGE_BANNER,
  'watch_how_it_works',
)

export const trackWatchHowItWorksOverlayShownFromMarketingEmail = (track) => track({
  name: TRACKING_EVENT_NAMES.CTA_SHOWN,
  properties: {
    cta_key: CTA_KEY.MARKETING_EMAIL,
    cta_text: 'email_agent_watch_how_it_works_overlay_shown',
  },
})

export const trackPopoverBannerWatchHowItWorksClicked = (track) => trackButtonClick(
  track,
  CTA_KEY.POPOVER_BANNER,
  'watch_how_it_works',
)

export const trackCallieHeroWatchHowItWorksClicked = (track) => trackButtonClick(
  track,
  CTA_KEY.CALLIE_HERO,
  'watch_how_it_works',
)

export const trackContinueToSetupClicked = (track, ctaKey) => trackButtonClick(
  track,
  ctaKey,
  'continue_to_setup',
)

export const trackLetCallieScheduleForYouClicked = (track) => trackButtonClick(
  track,
  CTA_KEY.SCHEDULING_PAGE,
  'let_callie_schedule_for_you',
)

export const trackSchedulingPageBannerDismissed = (track) => trackDismissAction(
  track,
  CTA_KEY.SCHEDULING_PAGE_BANNER,
  'email_agent_banner_dismissed',
)

export const trackPopoverBannerDismissed = (track) => trackDismissAction(
  track,
  CTA_KEY.POPOVER_BANNER,
  'email_agent_popover_banner_dismissed',
)

export const trackWatchHowItWorksOverlayDismissed = (track, ctaKey) => trackDismissAction(
  track,
  ctaKey,
  'email_agent_watch_how_it_works_overlay_dismissed',
)

export const trackEventTypeSelectionOverlayDismissed = (track, ctaKey) => trackDismissAction(
  track,
  ctaKey,
  'email_agent_event_type_selection_overlay_dismissed',
)

export const trackEventTypeSelectionSetAsDefaultClicked = (track, ctaKey) => trackButtonClick(
  track,
  ctaKey,
  'set_as_default',
)
